export default class Contact {
   constructor(bxItem) {
      this.id = bxItem.ID;
      this.name = bxItem.UF_CRM_1435680171;
      this.birthDate = new Date(bxItem.BIRTHDATE);
      if (Array.isArray(bxItem.PHONE)) {
         this.phone
      }
      this.phone = Array.isArray(bxItem.PHONE)
         ? bxItem.PHONE.map(item => item.VALUE).join(', ')
         : '';
      this.email = Array.isArray(bxItem.EMAIL)
         ? bxItem.EMAIL.map(item => item.VALUE).join(', ')
         : '';
      this.typeId = bxItem.UF_CRM_1435679741;
      this.ogrnIP = bxItem.UF_CRM_1435680228;
      this._ogrn = bxItem.UF_CRM_5A5DAC2E8C4A9;
      this.resident = bxItem.UF_CRM_1435680279;
      this.regDate = new Date(bxItem.UF_CRM_1435739220);
      this.crpId = bxItem.TYPE_ID;
      this.inn = bxItem.UF_CRM_1617196749;
      this.contactActivity = bxItem.UF_CRM_5B2CADFE276CB;
   }

   get ogrn() {
      return this._ogrn ? this._ogrn : this.ogrnIP
   }

   get type() {
      switch(this.typeId) {
         case '45': return 'contactType.scholar';
         case '47': return 'contactType.student';
         case '49': return 'contactType.unemployed';
         case '51': return 'contactType.retiree';
         case '53': return 'contactType.employee';
         case '55': return 'contactType.ooo';
         case '57': return 'contactType.ip';
         case '59': return 'contactType.ipndp';
         case '249': return 'contactType.selfEmployed';
         case '251': return 'contactType.other';
         default: return ''
      }
   }

   get crp() {
      switch(this.crpId) {
         case 'SHARE': return 'residentType.resident';
         case 'JOURNALIST': return 'residentType.client';
         case 'CLIENT': return 'residentType.customer';
         default: return 'residentType.not-resident';
      }
   }
}